import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { Autoplay, Navigation, Pagination } from 'swiper';
import 'swiper/modules/pagination/pagination.min.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper.min.css';
import { convertToLangKey, recordActivity } from '../../../AppUtil/AppUtil';
import BasicButtons from '../../Common/BasicButtons';
import MobileFooter from '../../Common/Profile/MobileFooter';
import AddToHomeScreen from '../../Home/AddToHomeScreen';
import UserBalanceHeader from '../../LoanList/UserBalanceHeader';
import './style.css';
import UserService from '../../../Service/UserService';
import { withRouter } from 'react-router';
import { hot } from 'react-hot-loader';

const colors = ['bg-pink', 'bg-purple', 'bg-green'];

class Landing extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isGuest: false,
			_balance: 0,
			_loading: false,

			users: {}
		};
	}

	isWorkFlowLoaded = () => {
		return this.props.activeWorkflows && this.props.activeWorkflows.length !== 0;
	};

	onWorkflowSelection = id => {
		this.props.setTypeOfWorkflowSelected(id);
		if (this.props.openedScreen === 'HOME') {
			this.props.openScreen('OPEN_WORKFLOW');
		}
	};

	formatName = user => {
		return user
			.split(' ')
			.map(word => word.charAt(0).toUpperCase() + word.slice(1))
			.join(' ');
	};

	updateBalance = async () => {
		this.setState({ _loading: true });
		try {
			const users = await UserService.getKycStatus({
				id: this.props.currentUser.profile.id,
				action: 'SUBMIT_KYC'
			});
			if (users) {
				this.setState({ users: users.item, _loading: false });
			}
		} catch (error) {
			this.setState({ _loading: false });
			console.log(error);
		}
	};

	componentDidMount() {
		recordActivity('ENTER', 'Lets Get Started');

		if (this.props.match.url == '/dashboard') {
			window.openScreen('LOAN_LIST');
		}

		if (this.props.error) {
			this.setState({ _error: this.props.error });
		} else {
			this.updateBalance();
		}
	}

	render() {
		const { t, currentUser } = this.props;

		const activeWorkflow = this.props.activeWorkflows;

		let user = currentUser ? currentUser.attributes.name : '';

		const onBoardingPictures = [
			`${process.env.PUBLIC_URL + 'images/onboarding_image_1.png'}`,
			`${process.env.PUBLIC_URL + 'images/onboarding_image_2.png'}`,
			`${process.env.PUBLIC_URL + 'images/onboarding_image_3.png'}`
		];
		const onBoardingTexts = [
			<span>
				Lending and Borrowing among <p className="onBoardingHeaderHighlight">Friends and Family</p> Made Easy
			</span>,
			<span>
				Easy <p className="onBoardingHeaderHighlight">step-by-step</p> process
			</span>,
			<span>
				We offer Formalized <p className="onBoardingHeaderHighlight">Person-to-Person</p> Loans
			</span>
		];

		const LoanType = () => {
			return (
				<>
					{user && (
						<div className="mdl-cell mdl-cell--12-col center-items">
							<UserBalanceHeader
								pending_balance={
									+this.state.users?.wallet_balance - +this.state.users?.usable_balance || 0
								}
								error={this.state._error}
								classContainer="dashboard-welcome-wrapper column landing_userbalance"
								user={this.formatName(user)}
								balance={this.state.users?.usable_balance || 0}
							/>
						</div>
					)}

					<div className="mdl-cell mdl-cell--12-col center-items landing_userbalance_title">
						<p className="text-center color-white main-top-heading">{t('home.title')}</p>
					</div>
					<div className="demo-container mdl-grid margin-top-20 start_a_loan ">
						<div className="mdl-cell mdl-cell--2-col mdl-cell--hide-tablet mdl-cell--hide-phone" />
						<div
							className="demo-content  mdl-color--white  mdl-shadow--4dp content
                                        mdl-color-text--grey-800 mdl-cell mdl-cell--8-col
                                        padding-20 min-250">
							<div className="mdl-grid workflow_container">
								<h1 className="main-content-heading">Choose a loan type:</h1>
								{(() => {
									if (this.isWorkFlowLoaded()) {
										if (activeWorkflow.length === 1) {
											return this.onWorkflowSelection(
												activeWorkflow.workflows[0].loan_workflow_id
											);
										} else {
											return activeWorkflow.workflows.map((workflow, index) => {
												return (
													<div
														className={`setup_new_loan mdl-cell mdl-cell--4-col mdl-cell--12-col-tablet mdl-cell--12-col-phone
                                            mdl-grid mdl-grid--no-spacing  ${workflow.background}  workflow ${
												workflow.loan_workflows[0].label ===
												'Setup Payments to Pay for Something'
													? 'disabled_process'
													: ''
											}`}
														key={index}
														onClick={() => {
															this.onWorkflowSelection(workflow.loan_workflow_id);
														}}
														style={{
															width: `calc(${100 / activeWorkflow.length}% - 16px)`
														}}>
														<img
															alt="setup a new loan"
															className="img-reponsive"
															src={workflow.loan_workflows[0].icon_path}
														/>
														<div className="text_container">
															<p>
																{t(
																	`home.${convertToLangKey(
																		workflow.loan_workflows[0].label
																	)}`
																)}
															</p>
															<p className="workflow_description">
																{workflow.loan_workflows[0].description}
															</p>
														</div>
													</div>
												);
											});
										}
									} else {
										return colors.map((color, index) => (
											<div
												className={`mdl-cell mdl-cell--12-col mdl-cell--12-col-tablet mdl-cell--12-col-phone
                                        mdl-grid mdl-grid--no-spacing  ${color} workflow loading`}
												key={index}>
												<img
													alt="setup a new loan"
													className="img-reponsive"
													onClick={() => {
														/* */
													}}
													src="/images/image-loader.gif"
												/>
											</div>
										));
									}
								})()}
							</div>
						</div>
					</div>
				</>
			);
		};

		return (
			<>
				{this.props.currentUser ? (
					<>
						<section className="start_a_loan_container">
							<LoanType />
							<div>
								<button
									className="dashboard-btn"
									onClick={() => {
										this.props.openScreen('LOAN_LIST');
									}}>
									Dashboard
								</button>
							</div>
							<MobileFooter hasBack={false} className="start_a_loan_footer" />
						</section>
					</>
				) : this.state.isGuest ? (
					<section className="start_a_loan_container">
						<LoanType />
						<MobileFooter hasBack={false} className="start_a_loan_footer" />
					</section>
				) : (
					<>
						<Swiper
							autoplay={{
								delay: 2500,
								disableOnInteraction: false
							}}
							pagination={{
								clickable: true,
								el: '.swiper-pagination-container .swiper-pagination'
							}}
							scrollbar={{ draggable: true }}
							style={{
								marginTop: 30,
								display: 'flex',
								marginLeft: 'auto',
								marginRight: 'auto',
								// backgroundColor: 'red',
								paddingBottom: 50
							}}
							spaceBetween={50}
							slidesPerView={1}
							modules={[Autoplay, Pagination, Navigation]}>
							{onBoardingTexts.map((value, index) => (
								<SwiperSlide key={index}>
									<div className="swiperWrapper">
										<h4 className="onBoardingHeader">{value}</h4>
										<div>
											<img
												src={onBoardingPictures[index]}
												alt={`Onboarding Image ${index}`}
												className="onBoardingImg"
											/>
										</div>
									</div>
								</SwiperSlide>
							))}
						</Swiper>
						<div className="swiper-pagination-container">
							<div className="swiper-pagination" />
						</div>
						<div>
							<div
								style={{
									margin: 'auto',
									marginTop: 30,
									backgroundColor: '',
									display: 'flex',
									justifyContent: 'space-between',
									maxWidth: '309px'
								}}>
								<BasicButtons
									onClick={() => {
										// if(!(this.props.currentUser)){
										//     this.props.openedScreen = 'AUTH';
										// }
										if (!this.props.currentUser) {
											this.props.openAuth('SIGN_UP');
											this.props.openScreen('AUTH');
										}
									}}
									type="signup"
									text="sign up"
									onBoarding
								/>
								<BasicButtons
									onClick={() => {
										if (!this.props.currentUser) {
											this.props.openAuth('SIGN_IN');
											this.props.openScreen('AUTH');
										}
									}}
									type="login"
									text="log in"
									onBoarding
								/>
							</div>
							<div
								onClick={() => {
									this.setState({ isGuest: true });
								}}
								style={{
									margin: 'auto',
									marginTop: 30,
									display: 'flex',
									justifyContent: 'center',
									alignItems: 'center',
									maxWidth: '190px',
									cursor: 'pointer',
									// backgroundColor: 'yellow',
									maxWidth: '309px'
								}}>
								<div className="continue-as-guest-btn">continue as guest</div>
								<div>
									<img width={22} height={22} src={process.env.PUBLIC_URL + 'images/default.svg'} />
								</div>
							</div>
						</div>
					</>
				)}
			</>
		);
	}
}

export default withRouter(hot(module)(withTranslation(['Core'])(Landing)));
